import { useState } from "react";
import { MqttProvider } from "./mqtt";
import { ConnectionBar } from "./ConnectionBar";
import { GenericPanel } from "./GenericPanel";
import { RobotPanel } from "./RobotPanel";

export function App() {
  const [tab, setTab] = useState<"robot" | "debug">("robot");

  return (
    <MqttProvider>
      <div className="app">
        <header className="app-header">
          <div>
            <h1>机器人测试台</h1>
            <p className="subtitle">MQTT over WebSocket · WebRTC 视频流 · 纯前端</p>
          </div>
          <ConnectionBar />
        </header>

        <nav className="tabs">
          <button className={tab === "robot" ? "active" : ""} onClick={() => setTab("robot")}>
            机器人控制台
          </button>
          <button className={tab === "debug" ? "active" : ""} onClick={() => setTab("debug")}>
            通用 MQTT 调试
          </button>
        </nav>

        <main>{tab === "robot" ? <RobotPanel /> : <GenericPanel />}</main>
      </div>
    </MqttProvider>
  );
}

export default App;
